function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { combineReducers } from 'redux';
import { rtkApi } from '../rtk';
import activity from './activity';
import alerts from './alert';
import apiReducer from './api';
import coverageReducer from './coverage';
import jobsReducer from './jobs';
import layout from './layout';
import mapReducer from './map';
import modal from './modal';
import order from './order';
import productsReducer from './products';
import profileReducer from './profile';
import project from './project';
import tourReducer from './tour';
import mpReducer from './mp';
var _obj;
var rootReducer = combineReducers((_obj = {
    layout: layout,
    alerts: alerts,
    jobsReducer: jobsReducer,
    profileReducer: profileReducer,
    productsReducer: productsReducer,
    mapReducer: mapReducer,
    modal: modal,
    activity: activity,
    order: order,
    project: project,
    coverageReducer: coverageReducer,
    tourReducer: tourReducer,
    apiReducer: apiReducer
}, _define_property(_obj, rtkApi.reducerPath, rtkApi.reducer), _define_property(_obj, "mpReducer", mpReducer), _obj));
export default rootReducer;
